import { ProcessingStatusEnum } from "../../models/enums/ProcessingStatusEnum";
import { Check, X, Clock, AlertCircle } from "lucide-react"
import { Badge } from "@mantine/core"

const StatusConfig = {
    [ProcessingStatusEnum.NotStarted]: { color: "gray", label: "Not Started", icon: <Clock size={14} /> },
    [ProcessingStatusEnum.InProgress]: { color: "blue", label: "Pending", icon: <Clock size={14} /> },
    [ProcessingStatusEnum.Processed]: { color: "blue", label: "Pending", icon: <Clock size={14} /> }, // Processed but not completed yet, waiting for ingestion
    [ProcessingStatusEnum.Completed]: { color: "teal", label: "Complete", icon: <Check size={14} /> },
    [ProcessingStatusEnum.Failed]: { color: "red", label: "Failed", icon: <X size={14} /> },
    [ProcessingStatusEnum.Cancelled]: { color: "orange", label: "Cancelled", icon: <AlertCircle size={14} /> },
    [ProcessingStatusEnum.ChunksCreated]: { color: "orange", label: "Chunks Created", icon: <Clock size={14} /> },
    [ProcessingStatusEnum.FailedToConvert]: { color: "red", label: "Failed to Convert", icon: <X size={14} /> },
    [ProcessingStatusEnum.FailedToCreateChunks]: { color: "red", label: "Failed to Create Chunks", icon: <X size={14} /> },
    [ProcessingStatusEnum.FailedToIngest]: { color: "red", label: "Failed to Ingest", icon: <X size={14} /> },
}

const ProcessingStatusBadge = ({ status }: { status: number }) => {
    const config = StatusConfig[status as keyof typeof StatusConfig]

    if (!config) {
        return null;
    }

    return (
        <Badge color={config.color} variant="filled" size="sm" radius="sm" leftSection={config.icon}>
            {config.label}
        </Badge>
    )
}

export default ProcessingStatusBadge;